import React, {useState, Fragment} from "react"
import { Dialog, Transition } from '@headlessui/react'

interface MyDialogProps{
    title?: string
    children: any,
    isOpen: boolean,
    btnPrimaryTxt?: string,
    btnSecondaryTxt?: string,
    handlerPrimaryButton? :any,
    handlerSecondaryButton? :any,
}

const MyModal:React.FC<MyDialogProps> = ({title=null, children, isOpen=false, btnPrimaryTxt, btnSecondaryTxt = null, handlerPrimaryButton, handlerSecondaryButton}) => {
    // let [isOpen, setIsOpen] = useState(true)

    function closeModal() {
        // setIsOpen(false)
    }

    function openModal() {
        // setIsOpen(true)
    }

    return (
        <Fragment>
            <Transition appear show={isOpen} as={Fragment}>
                {/*<Dialog as="div" className="relative z-10" onClose={closeModal}>*/}
                <Dialog as="div" className="relative z-10" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-50" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title as="h1" className="text-right text-xl pb-4 border-b font-medium leading-6 text-gray-900">
                                        {title}
                                    </Dialog.Title>
                                    <div className="text-right mt-2">
                                        {children}
                                    </div>

                                    <div className="mt-4 space-x">
                                        {btnSecondaryTxt && <button type="button" className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 mx-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2" onClick={handlerSecondaryButton}>
                                            {btnSecondaryTxt}
                                        </button>}
                                        {btnPrimaryTxt && <button type="button" className="inline-flex justify-center rounded-md border border-transparent bg-teal-100 px-4 py-2 mx-2 text-sm font-medium text-teal-900 hover:bg-teal-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2" onClick={handlerPrimaryButton}>
                                            {btnPrimaryTxt}
                                        </button>}
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </Fragment>
    )
}

export default MyModal